'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('incident', {
      url: '/incident/:id',
      params: {
        incident: null,
      },
      template: '<incident></incident>',
      // component: 'incident',
      // resolve: {
      //   incident: function($stateParams) {
      //     return $stateParams.incident;
      //   }
      //
      //   //['$stateParams', p => p.incident]
      // }
    });
}



// WEBPACK FOOTER //
// ./client/app/incident/incident.routes.js